export default __webpack_public_path__ + "static/media/spinner.48e221b3.gif";